// import "./update.scss";
// import Select from "react-select";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { classInputs } from "../../formSource";
// import { serverUrl } from "../../temp";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const statusOptions = [
//   { value: 1, label: "Active" },
//   { value: 0, label: "Inactive" },
// ];
// const classOptions = [
//   { value: "IX", label: "IX" },
//   { value: "X", label: "X" },
//   { value: "XI", label: "XI" },
//   { value: "XII", label: "XII" },
// ];

// const ClassUpdate = ({ title }) => {
//   // Extracting classId using regular expressions
//   const location = useLocation();
//   const classId = location.pathname.match(/\/update-class\/(\d+)/)?.[1];

//   // Initializing state
//   // const [file, setFile] = useState(null);
//   const [inputValues, setInputValues] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedName, setSelectedName] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchclass = async () => {
//       try {
//         const response = await fetch(`${serverUrl}/class/${classId}`, {
//           method: "GET",
//         });
//         if (!response.ok) {
//           throw new Error("Failed to fetch quiz");
//         }
//         const data = await response.json();
//         console.log("abbas", data);
//         // const snames = data.data.subject_names.split(",");
//         // const sid = data.data.subjects_id.split(",");
//         // // console.log("abbas1",abbas);
//         // const namelist = [];
//         // for (let i = 0; i < snames.length; i++) {
//         //   const name = snames[i];
//         //   console.log(name);
//         //   const id = sid[i]; // Access the "name" property
//         //   namelist.push({ value: id, label: name });
//         // }
//         const status = data.data.status;
//         if (status == 1) {
//           setSelectedStatus({ value: status, label: "Active" });
//         } else {
//           setSelectedStatus({ value: status, label: "Inactive" });
//         }
//         const name = data.data.name;
//         if (name == "IX") {
//           setSelectedName({ value: name, label: "IX" });
//         } else if (name == "X") {
//           setSelectedName({ value: name, label: "X" });
//         } else if (name == "XI") {
//           setSelectedName({ value: name, label: "XI" });
//         } else if (name == "XII") {
//           setSelectedName({ value: name, label: "XII" });
//         }
//         // setSelectedRoles(namelist);
//         setInputValues(data.data);
//         // setFile(data.data.logo);
//         localStorage.setItem("quizData", JSON.stringify(data));
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (classId) {
//       fetchclass();
//     }
//   }, [classId]);
//   // console.log("quiz in a state:", data);
//   const handleNameSelectChange = (selectedOption) => {
//     setSelectedName(selectedOption);
//     setInputValues({
//       ...inputValues,
//       name: selectedOption.value,
//     });
//   };
//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatus(selectedOption);
//     setInputValues({
//       ...inputValues,
//       status: selectedOption.value,
//     });
//   };

//   const handleInputChange = (e) => {
//     setInputValues({
//       ...inputValues,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("id", classId);
//     formData.append("center_id", localStorage.getItem("center_id"));
//     formData.append("name", inputValues.name);
//     formData.append("total_students", inputValues.total_students);
//     // formData.append("subjects_id", inputValues.subjects_id);
//     formData.append("status", parseInt(inputValues.status));
//     console.log(formData);
//     // Send formData to the server using an HTTP request to update
//     fetch(`${serverUrl}/upd_class/${classId}`, {
//       method: "PUT",
//       body: formData, // Send the data as form data
//     })
//       .then((response) => {
//         console.log(response);
//         return response.json();
//       })
//       .then((data) => {
//         if (data.code >= 400) {
//           if (typeof data.message === "object") {
//             Object.entries(data.message).forEach(([field, errors]) => {
//               errors.forEach((errMsg) => {
//                 toast.error(`${field}: ${errMsg}`);
//               });
//             });
//           } else {
//             toast.error(data.message || "Something went wrong.");
//           }

//           // setFilteredOptions(options); // Reset available roles

//           // Force the component to rerender with the empty state
//           setTimeout(() => {}, 500); // Adding timeout to allow state change
//         } else {
//           toast.success("Class updated successfully!");
//           setTimeout(() => {
//             navigate("/class");
//           }, 1000);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="update">
//           <Sidebar />
//           <div className="updateContainer">
//             <Navbar />
//             <div className="top">
//               <h1>{title}</h1>
//             </div>
//             <div className="bottom">
//               {/* <div className="left">
//                                 <img
//                                     src={
//                                         // file
//                                     }
//                                     alt=""
//                                     className="itemImg"
//                                 />
//                             </div> */}
//               <div className="right">
//                 <form onSubmit={handleUpdate}>
//                   {classInputs.map((input) => (
//                     <div className="formInput" key={input.id}>
//                       <label>{input.label}</label>
//                       {input.fieldName === "name" ? (
//                         <Select
//                           options={classOptions}
//                           name={input.fieldName}
//                           value={selectedName}
//                           onChange={handleNameSelectChange}
//                           required
//                         />
//                       ) : input.fieldName === "status" ? (
//                         <Select
//                           options={statusOptions}
//                           name={input.fieldName}
//                           value={selectedStatus}
//                           onChange={handleStatusSelectChange}
//                           required
//                         />
//                       ) : (
//                         <input
//                           type={input.type}
//                           placeholder={input.placeholder}
//                           name={input.fieldName}
//                           value={inputValues[input.fieldName] || ""}
//                           onChange={handleInputChange}
//                           required
//                           // inputMode={input.fieldName === 'no_of_quiz' ? 'numeric' : undefined}
//                         />
//                       )}
//                     </div>
//                   ))}
//                   <div style={{ clear: "both" }} className="formUpdate">
//                     <button
//                       style={{ float: "right" }}
//                       // onClick={() => navigate(`/class`)}
//                     >
//                       Update
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       type="button"
//                       style={{ float: "right" }}
//                       onClick={() => navigate(`/class`)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default ClassUpdate;
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { classInputs } from "../../formSource";
import { useLocation, useNavigate } from "react-router-dom";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import "./update.scss";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const classOptions = [
  { value: "IX", label: "IX" },
  { value: "X", label: "X" },
  { value: "XI", label: "XI" },
  { value: "XII", label: "XII" },
];

const ClassUpdate = ({ title }) => {
  const location = useLocation();
  const classId = location.pathname.match(/\/update-class\/(\d+)/)?.[1];
  const navigate = useNavigate();

  const [inputValues, setInputValues] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedName, setSelectedName] = useState(null);
  let [token] = useState(localStorage.getItem("token"));

  const redirectToLogin = () => {
    alert("Please Login first, then you can access this page...");
    window.location.href = "/";
  };

  useEffect(() => {
    const fetchClass = async () => {
      try {
        const response = await fetch(`${serverUrl}/class/${classId}`, {
          method: "GET",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch class data");
        }
        const data = await response.json();
        
        setSelectedStatus(
          data.data.status === 1
            ? { value: 1, label: "Active" }
            : { value: 0, label: "Inactive" }
        );
        
        setSelectedName(
          classOptions.find(opt => opt.value === data.data.name) || null
        );
        
        setInputValues(data.data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch class data.");
      }
    };

    if (classId) {
      fetchClass();
    }
  }, [classId]);

  const handleNameSelectChange = (selectedOption) => {
    setSelectedName(selectedOption);
    setInputValues({
      ...inputValues,
      name: selectedOption.value,
    });
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setInputValues({
      ...inputValues,
      status: selectedOption.value,
    });
  };

  const handleInputChange = (e) => {
    setInputValues({
      ...inputValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
    formData.append("id", classId);
    formData.append("center_id", localStorage.getItem("center_id"));
    formData.append("name", inputValues.name);
    formData.append("total_students", inputValues.total_students);
    formData.append("status", parseInt(inputValues.status));

    try {
      const response = await fetch(`${serverUrl}/upd_class/${classId}`, {
        method: "PUT",
        body: formData,
      });
      const data = await response.json();

      if (data.code >= 400) {
        if (typeof data.message === "object") {
          Object.entries(data.message).forEach(([field, errors]) => {
            errors.forEach((errMsg) => {
              toast.error(`${field}: ${errMsg}`);
            });
          });
        } else {
          toast.error(data.message || "Something went wrong.");
        }
      } else {
        toast.success("Class updated successfully!");
        setTimeout(() => {
          navigate("/class");
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {!token && redirectToLogin()}
      {token && (
        <div className="update">
          <Sidebar />
          <div className="updateContainer">
            <Navbar />
            <div className="contentWrapper">
              <Card className="formCard">
                <CardContent className="cardContent">
                  <Typography variant="h5" component="h2" gutterBottom className="formTitle">
                    {title}
                  </Typography>
                  <form onSubmit={handleUpdate} className="responsiveForm">
                    <Grid container spacing={2}>
                      {classInputs.map((input) => (
                        <Grid item xs={12} sm={6} key={input.id} className="formGridItem">
                          <div className="formInput">
                            <label>{input.label}</label>
                            {input.fieldName === "name" ? (
                              <Select
                                options={classOptions}
                                value={selectedName}
                                onChange={handleNameSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : input.fieldName === "status" ? (
                              <Select
                                options={statusOptions}
                                value={selectedStatus}
                                onChange={handleStatusSelectChange}
                                required
                                className="selectInput"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: '46px',
                                    borderColor: '#e2e8f0',
                                    '&:hover': {
                                      borderColor: '#cbd5e0'
                                    }
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    padding: '2px 8px'
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0'
                                  }),
                                  indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '44px'
                                  })
                                }}
                              />
                            ) : (
                              <input
                                type={input.type}
                                placeholder={input.placeholder}
                                name={input.fieldName}
                                value={inputValues[input.fieldName] || ""}
                                onChange={handleInputChange}
                                required
                              />
                            )}
                          </div>
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mt: 4, pb: 2 }}>
                      <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate("/class")}
                        sx={{ minWidth: '120px', height: '42px' }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '150px', height: '42px' }}
                      >
                        Update Class
                      </Button>
                    </Box>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </ThemeProvider>
  );
};

export default ClassUpdate;